<script>
import FiscalNotificationService from '../../services/fiscal-notification';
import EquipmentOperationService from '../../services/equipment-operation';
import config from '../../common/genericPanelConf';
import CommonConstants from '../../common/Constants';
import Utils from '../../common/Utils';
import Calendar from 'primevue/calendar';
import GenericCustomAutocompleteV2 from '../../components/generic/GenericCustomAutocompleteV2.vue'
import GenericCustomMasterDataAutocompleteV2 from '../../components/generic/GenericCustomMasterDataAutocompleteV2.vue'
import ResponsiveButton from '../../components/generic/ResponsiveButton.vue'
import GenericDataTable from '../../components/generic/GenericDataTable.vue'
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import SplitButton from 'primevue/splitbutton';
import Calculator from '../../components/tank-management/calculator/Calculator.vue';
import DialogBiodieselMixingReport from '../../components/operative-plan/daily-plan-management/DialogBiodieselMixingReport.vue';
import DialogTankInformation from '../../components/tank-management/TankInformationDialog.vue';
import DialogAggregations from '../../components/operative-plan/daily-plan-management/DialogAggregations.vue';

import { required } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";

export default{
    setup: () => ({ v$: useVuelidate() }),
    components: {
        GenericDataTable, SplitButton,
        TabView, TabPanel, Calculator,
        Calendar, GenericCustomAutocompleteV2, ResponsiveButton, GenericCustomMasterDataAutocompleteV2,
        DialogBiodieselMixingReport ,DialogAggregations, DialogTankInformation
    },
    created(){
        this.configuration = config.getConfiguration('DailyPlanManagement');
        this.operationConfiguration = {...config.getConfiguration('TankOperations')};
        this.operationConfiguration.customActions = [{
                title: 'btn.edit',
                visible: false,
                name: 'tankOperationsEditButton',
                icon: 'pi pi-pencil',
                data: {},
                fields: [],
                action: function (data, caller) {
                    let uri = `/tank/operations/${data.id}`;
                    caller.$router.push(uri);
                }
            }];

        this.aggregatedConfiguration = {...config.getConfiguration('DailyPlanManagement')};
        this.aggregatedConfiguration.customActions = [
            {
                name: 'addOperationAggregateButton',
                visible: false,
                cssClass: 'p-button-rounded p-button-success mr-2',
                icon: 'pi pi-arrow-up',
                data: {},
                fields: [],
                action: function(data, caller){
                    console.log(data)
                }
            }
        ];
        

        this.toAggregateConfiguration = {...config.getConfiguration('DailyPlanManagement')};
        this.toAggregateConfiguration.customActions = [
            {
                name: 'removeOperationAggregateButton',
                visible: false,
                cssClass: 'p-button-rounded p-button-success mr-2',
                icon: 'pi pi-arrow-down',
                data: {},
                fields: [],
                action: function(data, caller){
                    console.log(data)
                }
            }
        ];
    },
    mounted(){
        this.$store.dispatch('security/setNavbarTitle', 'dailyPlanManagement.page_title');
        this.loadFromCache();
    },
    data(){
        return{
            configuration: {},
            operationConfiguration: {},
            filters: {
                dailyPlanDate:new Date(),
                plantId: CommonConstants.defaultPlantId,
                tankCode: null,
                dateFrom: Utils.formatDatePlusDays(new Date(), -10),
                dateTo: Utils.formatDatePlusDays(new Date(), 0)
            },
            tanksList: [], 
            calculatorInput: {},
            selectedRecord: null,
            biodieselMixingDialogVisible: false,
            
            aggregationsBtnItems: [
                {
					label: 'Measurement Report',
					icon: 'pi pi-file-pdf',
					command: () => {}
				},
                {
					label: 'Biodiesel Mixing Report',
					icon: 'pi pi-table',
					command: () => {}
				}
            ],
            measurementReportDialogVisible: false,
            measurementReport: {
                // "idReport": 0,
                utifProgramCode: null,
                idOperativePlan: null,
                idRegistryProduct: null,
                billOfLadingWeight: null,
                billOfLadingVolume: null,
                notes: null
            },
            generalTankInfo: {},
            showTankInfoDialog: false
        }
    },
    validations(){
        return {
            filters: {
                dailyPlanDate: {required},
                plantId: {}
            }
        }
    },
    computed: {
        constants(){
            return CommonConstants;
        },
        utils(){
            return Utils;
        },
        addOperationDisabled(){
            let disabled = true;
            if(this.filters.tankCode && this.selectedRecord.registryOperationType != "SPZ" && (this.selectedRecord.status || this.selectedRecord.isSendToInfoilDisabledAndWriteToEqpmtOpsRegistryEnabled)){
                disabled = false;
            }
            return disabled;
        },
        isAzzPD(){
            let disabled = false;
            if(this.filters.tankCode && this.selectedRecord.registryOperationType == "AZZ PD"){
                disabled = true;
            }
            return disabled;
        },
        aggregationDisabled(){
            return !this.selectedRecord || !this.selectedRecord.isMainOperationOfAggregation || (this.selectedRecord.idMovementInstructionHeader == null);
        },
        fixedBalanceSplitDisabled(){
            return this.aggregationDisabled || this.selectedRecord.isFixedLot || this.selectedRecord.status == '' || this.selectedRecord.status == 'CA'  || this.selectedRecord.status == 'CC' ;
        },
        viewDetailsDisabled(){
            return !this.selectedRecord || !this.selectedRecord.isNotifyToCustomAgency || !this.selectedRecord.isMainOperationOfAggregation || this.selectedRecord.isSendToInfoilDisabledAndWriteToEqpmtOpsRegistryEnabled || (this.selectedRecord.status == '' && !Utils.isToday(this.filters.dailyPlanDate));
        },
        uiPermissions(){
            return this.$store.getters['security/uiPermissions'];
        },
        reportBtnItems(){
            return [
                {
					label: 'Measurement Report',
					icon: 'pi pi-file-pdf',
					command: () => {

                        // if transport type == N 
                        FiscalNotificationService.getMeasurementReportInitialData({idScheduled: this.selectedRecord.idScheduledOperation},
                            ({success, data, message}) => {
                                if(success){
                                    this.measurementReport = {...data};
                                    this.measurementReportDialogVisible = true;
                                }else{
                                    this.$toast.add({detail: message && message != '' ? message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                                }
                            }    
                        )

                        // this.measurementReportDialogVisible = true;
                        // if(this.selectedRecord.idScheduledOperation != null){
                        //     this.$store.dispatch("generic/setLoading", true);
                        //     let body = {idScheduledOperation:this.selectedRecord.idScheduledOperation };

                        //     FiscalNotificationService.printMeasurementReport(body, response => {
                                
                        //         this.$store.dispatch("generic/setLoading", false);
                        //         if(response.success){
                        //             var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                        //             var fileLink = document.createElement('a');
                                
                        //             fileLink.href = fileURL;
                        //             fileLink.setAttribute('download', 'Measurement_report.pdf');
                        //             document.body.appendChild(fileLink);
                                
                        //             fileLink.click();
                        //         }else{
                        //             this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                        //         }
                        //     })
                        // }
                    }
				},
                {
					label: 'Biodiesel Mixing Report',
					icon: 'pi pi-table',
					command: () => {
                        this.biodieselMixingDialogVisible = true;
                    }
				}
            ]
        } ,
    },
     methods: {
        loadFromCache(){
            let cacheData = this.$store.getters['cacheDataStore/getGridCache']('DailyPlanManagementGrid');
            if(cacheData){
                this.filters = {
                    dailyPlanDate: cacheData.dailyPlanDate,
                    plantId: cacheData.plantId,
                    // tankCode: cacheData.tankCode,
                    dateFrom: cacheData.dateFrom,
                    dateTo: cacheData.dateTo
                }
                this.selectedRecord = cacheData.selectedRecord;
                if(this.selectedRecord){
                    // this.populateCalculator(this.selectedRecord);
                    // this.populateTankList(this.selectedRecord);
                    this.$refs.operationGrid.setSelectedItem(this.selectedRecord);
                    this.onRowSelected(this.selectedRecord)
                }
            }

            
            this.load(true);
        },
        saveCache(){
            let cacheData = {
                name: 'DailyPlanManagementGrid',
                filters: {
                    plantId: this.filters.plantId,
                    dailyPlanDate: this.filters.dailyPlanDate,
                    selectedRecord: this.selectedRecord,
                    tankCode: this.filters.tankCode,
                    dateFrom: this.filters.dateFrom,
                    dateTo: this.filters.dateTo
                }
            };
            this.$store.dispatch("cacheDataStore/setGridCache", cacheData);
        },

        load(){
            this.submitted = true;

            let filters = {
                plantId: this.filters.plantId,
                dailyPlanDate: Utils.formatDateForAPI(this.filters.dailyPlanDate)
            }
            this.saveCache();            
            this.$refs.operationGrid.filterFromView(filters, true);
        },
        goToCommunication(){
            if(this.$refs.operationGrid.selectedItem){
                this.$router.push({name: 'last-fiscal-notification', query: {idScheduledOperation: this.$refs.operationGrid.selectedItem.idScheduledOperation}})
            }
        },
        goToFixedBalanceSplit(){
            if(this.$refs.operationGrid.selectedItem){
                this.$router.push({name: 'fixed-balance-split', query: {idScheduledOperation: this.$refs.operationGrid.selectedItem.idScheduledOperation}})
            }
        },
        onRowSelected(record){
            this.populateTankList(record);
            this.populateCalculator(record);
        },
        populateCalculator(record){
            this.calculatorInput = {
                tankCode: this.filters.tankCode, //record.tank,
                operationDate: null,
                inService: true,
                idRegistryProduct: record.idRegistryProduct,
                density15: null,
                measureType: 'Full',
                productLevel: null,
                environmentTemperature: null,
                temperature: null,
                feetPosition: null,
                waterLevel: null,
                calibrationTemperature: null,
                idOperativePlan: record.idScheduledOperation,
                isPartialMeasure: record.isPartialEndNotificationWithOnlyInputParams,
                idRegistryOperationType: record.idRegistryOperationType,
                registryOperationType: record.registryOperationType,
                otherTank: record.otherTank,
                mainTank: record.tank
            };
            this.selectedRecord = record;
            this.$refs.calculator.populateInput(this.calculatorInput);
        },
        populateTankList(record){
            this.tanksList = record.tankCompleteList;
            // this.filters.tankCode = null;
            this.$refs.tankSelectAC.changeStaticOptions(this.tanksList);
        },
        loadOperations(){
            let filters = [];
            this.saveCache();
            if(this.filters.tankCode && this.filters.dateFrom && this.filters.dateTo){
                filters.push({
                    operator: 'eq',
                    value: this.filters.tankCode,
                    property: 'TankCode',
                    propName: 'tankCode'
                });

                filters.push({
                    operator: '>=',
                    value: this.filters.dateFrom,
                    property: 'OperationDate',
                    propName: 'dateFrom'
                });

                filters.push({
                    operator: '<=',
                    value: Utils.formatEndDate(this.filters.dateTo),
                    property: 'OperationDate',
                    propName: 'dateTo'
                });
                
                this.$refs.operationsGrid.filterFromView(filters);

                this.calculatorInput.tankCode = this.filters.tankCode;
                this.$refs.calculator.populateInput(this.calculatorInput);
            }else{
                this.$refs.operationsGrid.resetGrid()
            }
        },
        openAddOperation(data, mode, tankCode, otherTankCode, fixedSender, isSender){

            if(this.selectedRecord && !this.selectedRecord.isSendToInfoilDisabledAndWriteToEqpmtOpsRegistryEnabled){
                FiscalNotificationService.canAddMeasure({
                    scheduledOperationId: this.selectedRecord.idScheduledOperation,
                    equipmentCode: this.filters.tankCode
                },
                (response) => {
                    if(response.success){

                        if(response.data){
                            this.$store.dispatch("operativePlan/setNewOperationData", {
                                idScheduledOperation: this.selectedRecord.idScheduledOperation,
                                data: {
                                    data: data,
                                    mode: mode,
                                    selectedRecord: this.selectedRecord,
                                    tankCode: tankCode,
                                    otherTankCode: otherTankCode,
                                    fixedSender: fixedSender,
                                    isSender: isSender
                                }
                            });
                            this.$router.push(
                                { 
                                    name: 'tank-operation-detail',
                                    params: {
                                        id: 0
                                    },
                                    query: {idScheduledOperation: this.selectedRecord.idScheduledOperation}
                                }
                            )
                        }else{
                            this.$toast.add({detail: this.$t('dailyPlanManagement.cannotAddOperation'), life:3000, severity:'error'});
                        }

                    }else{
                        this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                    }
                })
            }else if(this.selectedRecord && this.selectedRecord.status == 'CC'){
                this.$toast.add({detail: this.$t('dailyPlanManagement.cannotAddOperation'), life:3000, severity:'error'});
            }
            else{

                this.$store.dispatch("operativePlan/setNewOperationData", {
                    idScheduledOperation: this.selectedRecord.idScheduledOperation,
                    data: {
                        data: data,
                        mode: mode,
                        selectedRecord: this.selectedRecord,
                        tankCode: tankCode,
                        otherTankCode: otherTankCode,
                        fixedSender: fixedSender,
                        isSender: isSender
                    }
                });
                this.$router.push(
                    { 
                        name: 'tank-operation-detail',
                        params: {
                            id: 0
                        },
                        query: {idScheduledOperation: this.selectedRecord.idScheduledOperation}
                    }
                )
            }
        },
        addOperation(){
            FiscalNotificationService.getFiscalNotificationCheckForUpdate(this.selectedRecord.idScheduledOperation, (response) => {
                if (response.success && response.data != null) {                   
                    if(response.data.isMovementInstructionModified || response.data.isScheduledOperationModified){
                        let message = this.$t('dailyPlanManagement.warningOperationModified');

                        if(response.data.isMovementInstructionModified && !response.data.isScheduledOperationModified){

                            message = this.$t('dailyPlanManagement.warningOperationModifiedTelex');

                        }else if(!response.data.isMovementInstructionModified && response.data.isScheduledOperationModified){

                            message = this.$t('dailyPlanManagement.warningOperationModifiedScheduled');
                        }

                        this.$confirm.require({
                            message: message,
                            icon: 'pi pi-info-circle',
                            acceptLabel: this.$t('Ok'),
                            rejectLabel: this.$t('No'),
                            rejectClass: 'hidden p-button-outlined p-button-sm',
                            accept: () => this.$confirm.close(),
                        });
                    }
                } 
            })

            let fixedSender = this.selectedRecord.registryOperationType == 'TRV' || this.selectedRecord.registryOperationType == 'SPZ';

            if(this.selectedRecord.otherTank != null && this.filters.tankCode != this.selectedRecord.tank){
                this.$confirm.require({
                    message: this.$t('dailyPlanManagement.warningOperationOnReceiver'),
                    icon: 'pi pi-exclamation-triangle',
                    acceptLabel: this.$t('yes'),
                    rejectLabel: this.$t('no'),
                    accept: () => this.openAddOperation({ tankCode: this.filters.tankCode, idRegistryProduct: this.selectedRecord.idRegistryProduct}, 'TANK', this.selectedRecord.otherTank, this.selectedRecord.tank, fixedSender, false),
                    reject: () => this.$confirm.close()
                });
            }else{
                this.openAddOperation({ tankCode: this.filters.tankCode, idRegistryProduct: this.selectedRecord.idRegistryProduct}, 'TANK', this.filters.tankCode, this.selectedRecord.otherTank, fixedSender, true);
            }
        },
        populateOperation(data, mode){
            let fixedSender = this.selectedRecord.registryOperationType == 'TRV' || this.selectedRecord.registryOperationType == 'SPZ';

            if(this.selectedRecord.otherTank != null && this.filters.tankCode != this.selectedRecord.tank){

                this.$confirm.require({
                    message: this.$t('dailyPlanManagement.warningOperationOnReceiver'),
                    icon: 'pi pi-exclamation-triangle',
                    acceptLabel: this.$t('yes'),
                    rejectLabel: this.$t('no'),
                    accept: () => this.openAddOperation(data, mode, this.selectedRecord.otherTank, this.selectedRecord.tank, fixedSender, false),
                    reject: () => this.$confirm.close()
                });

            }else{
                this.openAddOperation(data, mode, data.tankCode, this.selectedRecord.otherTank, fixedSender, true);
            }
        },
        onTankSelected(){
        },
        closeBiodieselMixingReportDialog(value){
            this.biodieselMixingDialogVisible = !value;
        },
        closeTankInformationDialog(value){
            this.showTankInfoDialog = !value;
        },
        showAggregationsDialog(){
            this.$refs.aggregationsDialog.show();
        },
        printMeasurementReport(){
            FiscalNotificationService.createMeasurementReport({...this.measurementReport}, 
                ({success, data, message}) => {
                    if(success){
                        FiscalNotificationService.printMeasurementReport({id:data.id}, 
                        (response) => {
                            this.$store.dispatch("generic/setLoading", false);
                            if(response.success){
                                var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                                var fileLink = document.createElement('a');
                            
                                fileLink.href = fileURL;
                                fileLink.setAttribute('download', 'Measurement_report.pdf');
                                document.body.appendChild(fileLink);
                            
                                fileLink.click();
                                this.measurementReportDialogVisible = false;
                            }else{
                                this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                            }
                        })
                    }else{
                        this.$toast.add({detail: message && message != '' ? message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                    }
                }
            );
        }
     },
     watch: {
        'filters.plantId'(){
            this.load();
        },
        'filters.dailyPlanDate'(){
            this.load();
        },
        'filters.dateFrom'(){
            this.loadOperations();
        },
        'filters.dateTo'(){
            this.loadOperations();
        },
        'filters.tankCode'(){
            this.loadOperations();
        }
     }
}
</script>

<template>
    <main>
        <Dialog v-model:visible="measurementReportDialogVisible" modal closable :style="{width: '40vw'}">
            <div class="grid" >
                <div class="col-12 lg:col-6 field" v-if="measurementReport.showBillOfLadingData">
                    <label>{{$t('dailyPlanManagement.measurementReportBillOfLadingWeight')}}</label>
                    <InputNumber :minFractionDigits="3" :maxFractionDigits="3" v-model="measurementReport.billOfLadingWeight" :class="{'w-full p-inputtext-sm': true}" />
                </div>
                <div class="col-12 lg:col-6 field" v-if="measurementReport.showBillOfLadingData">
                    <label>{{$t('dailyPlanManagement.measurementReportBillOfLadingVolume')}}</label>
                    <InputNumber :minFractionDigits="3" :maxFractionDigits="3" v-model="measurementReport.billOfLadingVolume" :class="{'w-full p-inputtext-sm': true}" />
                </div>
                <div class="col-12 field">
                    <label>{{$t('dailyPlanManagement.measurementReportNotes')}}</label>
                    <Textarea v-model="measurementReport.notes" rows="5" cols="30" class="w-full"/>
                </div>
            </div>
            <template #footer>
                <Button :label="$t('btn.print')" icon="pi pi-print" @click="printMeasurementReport" />
            </template>
        </Dialog>

        <DialogAggregations ref="aggregationsDialog" :item="selectedRecord" />

        <DialogBiodieselMixingReport :visible="biodieselMixingDialogVisible" :idScheduled="selectedRecord?.idScheduledOperation" @close-biodiesel-mixing-report-dialog="closeBiodieselMixingReportDialog" />
        <DialogTankInformation :visible="showTankInfoDialog" :tankCode="filters?.tankCode" @close-tank-information="closeTankInformationDialog"/>
        <div class="grid">
            <div class="col-12 lg:col-2">
                <label for="from" :class="{'p-error':v$.filters.dailyPlanDate.$invalid && submitted}">{{$t('operativePlan.dailyPlanDate')}}</label>
                <Calendar
                    :class="{'p-invalid':v$.filters.dailyPlanDate.$invalid && submitted, 'p-inputtext-sm w-full': true}"
                    :placeholder="constants.DATE_PLACEHOLDER_POINT_ONLY_DATE"
                    :dateFormat="constants.DATE_FORMAT_POINT"
                    :showTime="false"
                    v-model="filters.dailyPlanDate"
                    :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
                <div v-if="(v$.filters.dailyPlanDate.$invalid && submitted) || v$.filters.dailyPlanDate.$pending.$response">
                    <small class="p-error" v-for="error in v$.filters.dailyPlanDate.$silentErrors" :key="error.$validator">
                        {{error.$message}}
                    </small>
                </div>
            </div>
            <div class="col-12 lg:col-2">
                <label for="plant" :class="{'p-error':v$.filters.plantId.$invalid && submitted}">{{$t('registryPlant.fk')}}</label>
                <GenericCustomMasterDataAutocompleteV2
                    field="label"
                    v-model="filters.plantId"
                    api="masterdata/registry-plant-combo"
                    :format="{ label: 'description', value: 'id' }"
                    :addEmpty="true"
                    :emptyValue="null"
                    :emptyLabel="$t('all')"
                        :name="'registry-plant'"
                    :class="{'p-invalid':v$.filters.plantId.$invalid && submitted, 'p-inputtext-sm w-full': true}" />
                <div v-if="(v$.filters.plantId.$invalid && submitted) || v$.filters.plantId.$pending.$response">
                    <small class="p-error" v-for="error in v$.filters.plantId.$silentErrors" :key="error.$validator">
                        {{error.$message}}
                    </small>
                </div>
            </div>
            <div class="col-12 lg:col-7">
                <div class="p-4">
                    <ResponsiveButton :label="$t('btn.refresh')" icon="pi pi-replay" class="mx-1" @click="load(!v$.$invalid)"/>   
            
                    <SplitButton :label="$t('reports')" icon="pi pi-file" :model="reportBtnItems" class="mx-1 p-button-sm" :disabled="!selectedRecord" />
                    <ResponsiveButton :label="$t('dailyPlanManagement.aggregations')" class="mx-1" :disabled="!uiPermissions('DailyPlan.AggregationButton').isEnabled || aggregationDisabled" @click="showAggregationsDialog"/>
                    <ResponsiveButton :label="$t('dailyPlanManagement.fixedBalanceSplit')" class="mx-1" :disabled="!uiPermissions('DailyPlan.FixedBalanceSplitButton').isEnabled || fixedBalanceSplitDisabled" @click="goToFixedBalanceSplit"/>
                    <ResponsiveButton :label="$t('btn.viewDetails')" icon="pi pi-file" class="mx-1 " @click="goToCommunication" :disabled="viewDetailsDisabled"/>
                </div>
            </div>

            <div class="col-12" style="height: calc(75vh)">
                <GenericDataTable :configuration="configuration" :category="'daily-plan'" :name="'management'" ref="operationGrid" :onRowSelectFn="onRowSelected"/>
            </div>
            <div class="col-12 lg:col-2 field m-3">
                <label for="tank">{{$t('tankOperations.tank')}}</label>
                <GenericCustomAutocompleteV2
                    :onItemSelect="onTankSelected"
                    ref="tankSelectAC"
                    :class="{'p-inputtext-sm w-full': true}"
                    v-model="filters.tankCode"
                    :staticOptions="tanksList"
                    :selectFirst="true"
                    name="tank-management-tank-combo"
                    :format="{ label: 'label', value: 'label' }" />
            </div>
            <div class="col-12 lg:col-2 field m-3">
                <label for="from">{{$t('from')}}</label>
                <Calendar
                    :class="{'p-inputtext-sm w-full': true}"
                    :placeholder="constants.DATE_PLACEHOLDER_POINT_ONLY_DATE"
                    :dateFormat="constants.DATE_FORMAT_POINT"
                    :showTime="false"
                    v-model="filters.dateFrom"
                    :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
            </div>
            <div class="col-12 lg:col-2 field m-3">
                <label for="to">{{$t('to')}}</label>
                <Calendar
                    :class="{'p-inputtext-sm w-full': true}"
                    :placeholder="constants.DATE_PLACEHOLDER_POINT_ONLY_DATE"
                    :dateFormat="constants.DATE_FORMAT_POINT"
                    :showTime="false"
                    v-model="filters.dateTo"
                    :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
            </div>
            <div class="col-12 m-2" style="height: calc(75vh)">
                <TabView >
                    <TabPanel :header="$t('tankOperations.page_title')">
                        <ResponsiveButton :label="$t('btn.add')" icon="pi pi-plus" class="mx-1 p-button-sm" @click="addOperation" :disabled="!uiPermissions('tankOperationsAddButton').isEnabled ||addOperationDisabled"/>
                        <ResponsiveButton :label="$t('tankOperations.btn.showTankInfo')" icon="pi pi-database" class="mx-1 p-button-sm p-button-outlined" @click="showTankInfoDialog = true" :disabled="addOperationDisabled"/>
                        <div style="height: calc(60vh)">
                            <GenericDataTable :configuration="operationConfiguration" :category="'tank'" :name="'operations'" ref="operationsGrid"/>
                        </div>
                    </TabPanel>
                    
                    <TabPanel :header="$t('tankCalculator.calculator')">
                        <Calculator ref="calculator" @populate-operation="populateOperation" :disableImport="!uiPermissions('tankOperationsAddButton').isEnabled || addOperationDisabled || isAzzPD" />
                    </TabPanel>
                </TabView>
            </div>
        </div>
    </main>
</template>